var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loader-overlay"},[_c('div',{staticClass:"custom-loader"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }